export default {
    getId(): number {
        return Math.random();
    },
    push(id: number) {
        if (!window.modalRegistry) {
            window.modalRegistry = [];
        }

        window.modalRegistry.push(id);
    },
    getLast(): number | null {
        if (!window.modalRegistry) {
            return null;
        }

        if (window.modalRegistry.length === 0) {
            return null;
        }

        return window.modalRegistry[window.modalRegistry.length - 1];
    },
    pop(): void {
        if (!window.modalRegistry) {
            return;
        }

        if (window.modalRegistry.length === 0) {
            return;
        }

        window.modalRegistry.pop();
    },
};
